import chatbotRequest from '@/service/channel/http'
import type { AddRoomTagReq, AddRoomTagRes } from '../type/addRoomTag'

export function addRoomTagApi(data: AddRoomTagReq): Promise<AddRoomTagRes> {
    return chatbotRequest<AddRoomTagRes, AddRoomTagReq, AddRoomTagRes>({
        url: '/api/room/tag/add',
        method: 'post',
        data,
    })
}